import { useState } from 'react';

import StarRateIcon from '@mui/icons-material/StarRate';

export const ProfilePicture: React.FC<{
  url: string | null;
  style?: React.CSSProperties;
}> = ({ url, style }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      style={{
        width: '40px',
        height: '40px',
        backgroundColor: imgError || !url ? '#00000099' : 'transparent',
        overflow: 'hidden',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      {!imgError && !!url ? (
        <img
          src={url}
          alt="Avatar"
          onError={() => setImgError(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      ) : (
        <StarRateIcon sx={{ color: '#fff' }} fontSize="small" />
      )}
    </div>
  );
};
